<template>
  <div class="login_wrap" v-loading="loading">
    <div>
      <div class="title">
        <div>{{ language("login.title") }}</div>
        <div>{{ language("login.subTitle") }}</div>
      </div>
      <div class="login_form">
        <el-form
          :model="form"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
          label-position="left"
        >
          <el-form-item :label="language('login.loginName')" prop="username">
            <el-input
              v-model="form.username"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="language('login.password')" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="off"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div>
              <el-checkbox v-model="checked">{{
                language("login.remember")
              }}</el-checkbox>
            </div>
            <el-button type="primary" @click="submitForm('ruleForm')">{{
              language("login.submit")
            }}</el-button>
            <div>
              <el-link :underline="false" @click="gotoForgot">{{
                language("login.forgot")
              }}</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      form: {
        // password: "676HmmJT",
        // username: "deadline_0122@163.com",
      },
      rules: {
        username: [
          {
            required: true,
            message: "",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "",
            trigger: "change",
          },
        ],
      },
      checked: false,
    };
  },
  methods: {
    random() {
      let code = [
        "Q",
        "W",
        "E",
        "T",
        "Y",
        "U",
        "I",
        "O",
        "P",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
      ];
      var num = "";
      for (var i = 0; i < 5; i++) {
        num += code[Math.floor(Math.random() * 19)];
      }
      return num;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.remember = this.checked ? "on" : "off";
          // 登录
          this.ccRequest
            .do("admin/merchant/user/login", this.form, "POSTJSON")
            // .do("loginJson", this.form)
            .then((res) => {
              //記住密碼
              if (this.checked) {
                let data = window.btoa(window.btoa(JSON.stringify(this.form)));
                localStorage.setItem(
                  process.env.VUE_APP_logoKey,
                  this.random() + data
                );
              } else {
                localStorage.removeItem(process.env.VUE_APP_logoKey);
              }

              localStorage.setItem(
                process.env.VUE_APP_shiroUserName,
                res.shiroUser.name
              );
              this.loading = false;
              this.getUserData();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.response.data.message);
              if (err.response.data.message == "初次登陸請修改密碼後重新登陸") {
                let userData = {
                  username: this.form.username,
                  oldPassword: this.form.password,
                };
                let data = window.btoa(window.btoa(JSON.stringify(userData)));
                localStorage.setItem(
                  process.env.VUE_APP_resetKey,
                  this.random() + data
                );
                this.$router.push({ path: "/reset" });
              }
            });
        } else {
          return false;
        }
      });
    },
    getUserData() {
      this.$router.push({ path: "/home" });
    },
    change() {
      // alert(1);
    },
    gotoForgot() {
      if (this.form.username) {
        let userData = {
          username: this.form.username,
        };
        let data = window.btoa(window.btoa(JSON.stringify(userData)));
        localStorage.setItem(
          process.env.VUE_APP_resetKey,
          this.random() + data
        );
      }
      this.$router.push({ path: "/forgot" });
    },
  },
  mounted() {
    if (localStorage.getItem(process.env.VUE_APP_logoKey)) {
      try {
        let data = JSON.parse(
          window.atob(
            window.atob(
              localStorage.getItem(process.env.VUE_APP_logoKey).substring(5)
            )
          )
        );
        this.form = { ...data };
        this.checked = true;
      } catch (error) {}
    }
  },
};
</script>
<style lang="scss">
.login_wrap {
  .el-form-item__label {
    font-weight: 600;
  }
}
</style>
<style scoped lang="scss">
.login_wrap {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  padding: 0 0 20px 0;
  margin: 0 auto;
  color: $mainColor;
  font-weight: 600;
  border-bottom: 1px solid #259b24;
  width: 620px;
  div {
    text-align: center;
    font-size: 36px;
  }
}
.login_form {
  margin: 50px auto 0 auto;
  width: 350px;
}
</style>